/**
 * JRS theme – shared analytics helper (GA4 + dataLayer for GTM).
 * Use: jrsTrackEvent('event_name', { param: value }, { prefix: 'jrs_', event_category: 'optional' })
 * Opt-in: with { transport: 'datalayer' } the gtag call is skipped and the event is pushed to the
 * dataLayer only, for names already sent by a GTM tag (with gtag as well, each was counted twice).
 * { eventCallback: fn } is passed on that push as GTM's eventCallback with eventTimeout 400.
 * Callers keep their own fallback timer: no callback is made when GTM is blocked or not loaded.
 */
(function () {
  'use strict';

  var defaultPrefix = 'jrs_';

  function getDeviceType() {
    return typeof window !== 'undefined' && window.innerWidth < 750 ? 'mobile' : 'desktop';
  }

  function jrsTrackEvent(eventName, params, options) {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;
    if (!eventName || typeof eventName !== 'string') return;
    var opts = options || {};
    var prefix = opts.prefix !== undefined ? opts.prefix : defaultPrefix;
    var fullName = prefix ? prefix + eventName : eventName;
    var eventParams = Object.assign(
      { device_type: getDeviceType() },
      params || {}
    );
    if (opts.event_category) {
      eventParams.event_category = opts.event_category;
    }
    if (opts.transport !== 'datalayer' && typeof window.gtag === 'function') {
      window.gtag('event', fullName, eventParams);
    }
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      try {
        var entry = {
          event: fullName,
          ...eventParams
        };
        if (typeof opts.eventCallback === 'function') {
          entry.eventCallback = opts.eventCallback;
          entry.eventTimeout = 400;
        }
        window.dataLayer.push(entry);
      } catch (e) {
        console.error('[JRS-GA4]', e);
      }
    }
  }

  window.jrsTrackEvent = jrsTrackEvent;

  // PDP helper for the jrsPDPTrack call sites left behind when pdp-tracking.js was
  // retired (2026-09-01). dataLayer only, never gtag: each allowed name already has its
  // own GTM tag, so a gtag call would double it. Names outside the allowlist no-op, which
  // keeps the first release to five events (ClickUp: PDP tracking audit, Step 2).
  var PDP_ALLOWED = {
    pdp_guarantee_popup_open: true,
    pdp_logo_proof_popup_open: true,
    pdp_cvd_drawer_open: true,
    pdp_faq_expand: true,
    pdp_configurator_start: true
  };

  function jrsPDPTrack(eventName, params) {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;
    if (!PDP_ALLOWED[eventName]) return;
    window.dataLayer = window.dataLayer || [];
    try {
      window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
    } catch (e) {
      console.error('[JRS-GA4]', e);
    }
  }

  // Call sites gate on window.jrsProductId, which only bundle-new sets. Fill it on every
  // PDP from Shopify's own page meta; never overwrite a value a section already set.
  if (!window.jrsProductId) {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (meta && meta.product && meta.product.id) window.jrsProductId = meta.product.id;
  }

  window.jrsPDPTrack = jrsPDPTrack;
})();
